import { createBrowserRouter } from 'react-router-dom'
import { NotFoundPage } from './pages/NotFoundPage'
import { AdminRoutes } from './AdminRoutes'
import { SuperUserRoutes } from './SuperUserRoutes'
import { StoreRoutes } from './StoreRoutes'
import { EmbedRoutes } from './EmbedRoutes'

export const router = createBrowserRouter([
  // Ticket is denormalized and has a HASH index of ticketId.  Only needs react-router and the U.I.
  // We separate it from everything else in the app
  { path: '/ticket/:ticketId', lazy: () => import('./pages/ticket.$ticketId') },

  { path: '/store/:oid/embed',
    lazy: () => import('./pages/_barebonesLayout'),
    children: [
      {path: 'calendar', lazy: () => import('./pages/embed.$oid.calendar')},
      {path: 'festivals/:pid/calendar', lazy: () => import('./pages/embed.$oid.festivals.$pid.calendar')},
    ]
  },
  {
    path: '/', lazy: () => import('./pages/_index'),
    children: [
      // These embeds are designed to be used in an iframe, so they do not use any
      // layouts. They are nested just deeply enough to get the needed context
      { path: '__/auth/action', lazy: () => import('./pages/__.auth.action') },
      // Marketing pages under shared layout
      {
        path: '',
        lazy: () => import('./pages/_marketing'),
        children: [
          { path: '', lazy: () => import('./pages/index') },
          { path: 'features', lazy: () => import('./pages/features') },
          { path: 'pricing', lazy: () => import('./pages/pricing') },
          { path: 'how-it-works', lazy: () => import('./pages/how-it-works') },
          { path: 'about', lazy: () => import('./pages/about') },
          // Careers — temporarily disabled. Left unregistered on purpose so the
          // page is unreachable even by direct URL (falls through to the 404),
          // and so its only dynamic import is gone and the chunk never ships.
          // Restore this line to bring it back; pages/careers.tsx stays in place.
          // { path: 'careers', lazy: () => import('./pages/careers') },
          { path: 'for', lazy: () => import('./pages/for') },
          { path: 'for/:vertical', lazy: () => import('./pages/for.$vertical') },
          { path: 'support', lazy: () => import('./pages/support') },
          { path: 'support/:slug', lazy: () => import('./pages/support.$slug') },
          { path: 'support/:category/:slug', lazy: () => import('./pages/support.$category.$slug') },
        ],
      },
      { path: 'organization-privacy-policy', lazy: () => import('./pages/organization-privacy-policy') },
      { path: 'organization-tos', lazy: () => import('./pages/organization-tos') },
      { path: 'my-tickets', lazy: () => import('./pages/my-tickets') },
      { path: 'getting-started', lazy: () => import('./pages/getting-started') },
      { path: 'staff/:oid/schedule/:uid', lazy: () => import('./pages/staff.$oid.schedule.$uid') },
      { path: 'my-tickets', lazy: () => import('./pages/my-tickets') },
      { path: 'staff',
        children: [
          { path: ':oid/schedule/:uid', lazy: () => import('./pages/staff.$oid.schedule.$uid')}
        ]
      },
      {
        path: '/embed',
        lazy: () => import('./pages/_barebonesLayout'),
        children:  EmbedRoutes
      },
      {
        path: 'store',
        lazy: () => import('./pages/_store'),
        children: StoreRoutes,
      },
      {
        path: 'admin',
        children: [
          { path: '', lazy: () => import('./pages/admin') },
          { path: 'create-organization', lazy: () => import('./pages/admin.create-new-organization') },
          {
            path: 'su',
            lazy: () => import('./pages/admin._su'),
            handle: { layout: true },
            children: SuperUserRoutes
          },
          {
            path: ':oid',
            lazy: () => import('./pages/admin._$oid'),
            handle: { layout: true },
            children: AdminRoutes,
          },
        ],
      }
    ]
  },
  { path: '*', element: <NotFoundPage goBackPath='/' goBackText='Go back home' /> },
]) as any
